import styled from '@emotion/styled';

import COLOR from '../../../../shared/constant/colorset';
import { addComma } from '../../../../shared/services';
import { PriceService } from '../../../service/priceService';
import { getDealDisabledText } from '../../shared/utils/productDetailState';

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

const Description = styled.p`
  display: flex;
  flex: 1;
  flex-direction: column;
`;

const Name = styled.span<{ disabled: boolean; }>`
  display: flex;
  max-width: 240px;
  line-height: 16px;
  font-size: 12px;
  letter-spacing: -0.5px;
  word-break: keep-all;
  ${({ disabled }) => disabled && `color: ${COLOR.kurlyGray350}`};
`;

const NotExpectedPointText = styled.span<{ disabled: boolean; }>`
  font-size: 12px;
  line-height: 16px;
  letter-spacing: -0.5px;
  color: ${({ disabled }) => disabled ? COLOR.kurlyGray350 : COLOR.kurlyGray600};
  margin-top: 4px;
`;

const PriceWrapper = styled.div`
  display: flex;
  align-self: center;
  flex-shrink: 0;
  gap: 4px;
`;

const BasePrice = styled.div<{ disabled: boolean; }>`
  margin-left: 50px;
  text-decoration: line-through;
  font-size: 12px;
  color: ${({ disabled }) => disabled ? COLOR.kurlyGray350 : COLOR.kurlyGray400};
`;

const DiscountedPrice = styled.div<{ disabled: boolean; }>`
  font-size: 12px;
  font-weight: bold;
  color: ${({ disabled }) => disabled ? COLOR.kurlyGray350 : COLOR.kurlyGray800};
`;

interface Props {
  description: string | null;
  basePrice: number;
  retailPrice: number | null;
  discountedPrice: number | null;
  isSoldOut: boolean;
  isPurchaseStatus: boolean;
  isExpectedPoint?: boolean;
}

export default function DropdownItem({
  description,
  basePrice,
  retailPrice,
  discountedPrice,
  isSoldOut,
  isPurchaseStatus,
  isExpectedPoint = true,
}: Props) {
  const {
    representativePrice,
    kurlyPrice,
    originalPrice,
  } = new PriceService({ retailPrice, basePrice, discountedPrice });

  const originPrice = kurlyPrice ?? originalPrice;

  const disabledText = getDealDisabledText({ isPurchaseStatus, isSoldOut });

  const disabled = isSoldOut || !isPurchaseStatus;

  return (
    <Container>
      <Description>
        <Name disabled={disabled}>
          {disabledText && `(${disabledText}) `}
          {description}
        </Name>
        {!isExpectedPoint && (
          <NotExpectedPointText disabled={disabled}>
            적립제외상품
          </NotExpectedPointText>
        )}
      </Description>
      {!!representativePrice && (
        <PriceWrapper>
          {originPrice && (
            <BasePrice disabled={disabled}>
              {`${addComma(originPrice)}원`}
            </BasePrice>
          )}
          <DiscountedPrice disabled={disabled}>
            {`${addComma(representativePrice)}원`}
          </DiscountedPrice>
        </PriceWrapper>)}
    </Container>
  );
}
